import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 发送验证码
  getSendCheckCode(_postData) {
    return http.post(URL.API_COMMON_SMS_SEND_CHECK_CODE, _postData)
  },
  // 校验验证码
  getValidCheckCode(_postData) {
    return http.post(URL.API_COMMON_SMS_VALID_CHECK_CODE, _postData)
  },
  // 查询明日课表通知配置
  getScheduleConfig(_postData) {
    return http.post(URL.API_SCHEDULE_GET_NOTIFY_CONFIG, _postData)
  },
  // 保存明日课表通知配置
  saveScheduleConfig(_postData) {
    return http.post(URL.API_SCHEDULE_SAVE_NOTIFY_CONFIG, _postData)
  },
  // 领取礼包
  getGift(_postData) {
    return http.post(URL.API_COMMON_RECEIVE, _postData)
  },
  // 查询班级列表（支持按校区、年级查询，支持指定显示在最前面的班级DingId）
  getCommonQueryClass(_postData) {
    return http.post(URL.API_COMMON_QUERY_CLASS, _postData)
  },
  // 查询课程列表（只返回课程id、课程名称）
  getCommonSimpleList(_postData) {
    return http.post(URL.API_COURSE_SIMPLE_LIST, _postData)
  },
  // 上传临时文件
  uploadTemporaryFile(propsData) {
    return new Promise((resolve, reject) => {
      http
        .uploadFile(URL.API_UPLOAD_TEMPORARY_FILE, propsData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取通用 banner
  getCommonBanner(propsData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CUSTOM_GET_BANNER_LIST, propsData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 消除公告弹窗的配置
  clearModulePopup(_postData) {
    return http.get(URL.API_ANNOUNCEMENT_CLEAR_MODULE, _postData)
  },
  // 查询某人公告弹窗的配置集合
  listModulePopup(_postData) {
    return http.get(URL.API_ANNOUNCEMENT_MODULE, _postData)
  },
  // 根据短链获取校区信息
  getCampusInfoByShortLink(params) {
    return http.get(URL.API_GET_SHORT_LINK_INFO, params)
  },
  // 筛选范围 返回自定义角色下的管理范围用于反显
  getRoleGroupUserRange(params) {
    return http.post(URL.API_H5_ROLE_GROUP_USER_RANGE, params)
  },
  // 用户老师角色
  getTeacherRole(params) {
    return http.get(URL.API_H5_ROLE_GET_TEACHER_ROLE, params)
  },
  // 判断家长是否有使用魔点校园的权限
  judgeGuardianSchoolAppAuth(params) {
    return http.get(URL.API_JUDGE_GUARDIAN_APP_AUTH, params)
  },
  // 自定义通知角色组管理
  getRoleGroupList(params) {
    return http.get(URL.API_ROLE_GROUP_LIST, params)
  },
  // 校园监控-手机端扫码登陆
  aiScanLogin(_postData) {
    return http.post(URL.API_SCHOOL_SECURITY_SCANLOGIN, _postData)
  },
  // 校园监控 - 查询某个机构下的所有摄像头设备
  getScanDeviceList(_postData) {
    return http.post(URL.API_SCHOOL_SECURITY_DEVICE_LIST, _postData)
  },
  // 获取机构信息
  getCampusOrgInfo(params) {
    return http.get(URL.API_CAMPUS_ORG_INFO, params)
  },
  // 魔方人脸库来源 GET
  getFaceSource(params) {
    return http.get(URL.API_GET_FACE_SOURCE, params)
  },

  // 绑定校区/告警类型/区域
  bindAlertInfoH5(params) {
    return http.post(URL.API_BIND_ALERT_INFO_H5, params)
  },

  // 获取告警区域列表
  queryDisciplinaryAreaListH5(params) {
    return http.post(URL.API_QUERY_DISCRIMINAL_AREA_LIST_H5, params)
  },

  // 获取告警类型列表
  queryDisciplinaryTypeListH5(params) {
    return http.post(URL.API_QUERY_DISCRIMINAL_TYPE_LIST_H5, params)
  },
  getOrgGrayFunctionList(params) {
    return http.get(URL.API_GET_ORG_GRAY_FUNCTION, params)
  },
  getDeviceIdBySn(params) {
    return http.get(URL.API_GET_DEVICEIO_BY_SN, params)
  },
  // 自定义配置获取
  getCustomConfig(params) {
    return http.post(URL.API_GET_CUSTOM_CONFIG, params)
  },
  // 根据排课任务id查询年级树（年级 -> 班级）
  getGradeTree(postData) {
    return http.get(URL.API_GET_GRADE_TREE, postData)
  },
  // 获取机构标签信息
  apiGetTags(postData) {
    return http.get(URL.API_TAG_GET_TAGS, postData)
  }
}
